
var state = {
  schoolname:'',
  // 列表页
  subjectarry:['语文','数学','英语','化学','生物','地理','历史','道德与法治','信息技术','通用技术','科学'],//绑定身份选择科目
  gradearr:'',//绑定身份选择年级
  projectid:'',//项目id
	nowrole:'',//当前角色，
  nowsubject:'',//当前科目
  subjectlist:'',//所有科目试卷
  examlist:'',//试卷对应
  tabactive:'0',//当前科目索引
  index:'0',//左侧导航当前显示
  examid:'',//考试科目id
  nowclass:'',//默认当前班级
  calsslist:'',//参加考试的所有班级
  // 左侧按钮
  examinfo:'',//考试信息
  top_nav:[
    {
     title:'首页概述',
     icon1:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/home.png',
     icon2:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/homes.png',
    },
    {
     title:'重要数据统计',
     icon1:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/shuju.png',
     icon2:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/shujus.png',
    },
    {
     title:'试题分析',
     icon1:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/shiti.png',
     icon2:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/shitis.png',
    },
    {
     title:'试题知识点分析',
     icon1:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/zsd.png',
     icon2:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/zsds.png',
    },
  ],
  // 左侧按钮
  top_navall:[
    {
     title:'首页概述',
     icon1:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/home.png',
     icon2:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/homes.png',
    },
    {
     title:'重要数据统计',
     icon1:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/shuju.png',
     icon2:'https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newlesson/analysis/shujus.png',
    },
  ],
  // ---------------------------------------首页 ----------------
  // 数据分析 页面数据
   // 成绩
   allscroe:'',
   Statistics:'',//四率统计
   StatisticsTitle:'',//四率title
   ranking:'',//各班与上次排名对比
   subsectionall:'',//各班分班统计图 全可
   subsectionclass:'',//当前分段班级
   // 单科独有
   Losetimu:'',//丢分最多的五道题
   Losezsd:'',//丢分最多的五个知识点
   Losezsdes:'',//知识点分析页面列表
   // 重要数据统计
   tablist:['上线统计','命中率贡献率','临界生','学生成绩排名','学生分段统计','各档学生平均分','名次段人数占比'],
   promptTitle:[
   	'比较各班之间，第1分段、第2分段的单科及总分的过线人数',
   	'各校之间的上线人数，命中率与贡献率的对比',
   	'查看本年级临界生的贡献值',
   	'查看学生总分成绩排名和所教学科成绩排名',
   	'比较分数段相同的学生，在各班的分布数量',
   	'比较各班级各档学生的平均成绩',
    '查看名次段人数分布占比'
   	],
    allAvgCompare:'',//科目均衡对比列表
    // ---------------单科上线统计
    SingleCountall:'',//全科上线人数
    SingleCount:'',//单科上线人数
    Singlsit:'',//上线成员咧白哦

     // 命中率 贡献率
     oneRatio:'',
     twoRatio:'',

    // 临界值
    Criticalup:'',//临界上
    Criticaldown:'',//临界下
    Critical:[],//临界是否有

    //学生成绩排名
    rnkp:1,
    rnks:10,
    rnktotal:0,
    SingleRank:'',

    // 平均分列表
    avglist:'',
    maxnum:'',//最大

    //分段统计
     segment:'',
     segmentmax:'',//最大值

    // 试题分析页面
    timulist:'',
    timudefault:'',//试题情况
    nowdatika:'',//默认选择
    timutype:'',//默认选择类型
    timuid:'',//moren1,
    timuclass:'',
    AnswerScore:'',//xueshengzhanbi
    AnswerType:'',
    QuestionInfo:'',//
    subjectclass:[],//科目对应班级
    moretimuclass:'',//多选的科目


}
export default state



// WEBPACK FOOTER //
// ./src/store/modules/analysis/state.js